<template>
    <div class="cst-survey-datepicker">
        <datepicker :language="locale" :calendar-button="false" calendar-button-icon="fa fa-calendar" wrapper-class="cst-survey-customer-field" input-class="cst-survey-datepicker-input" :placeholder="' '+$t('pickDate')" :monday-first="true" v-model="date"></datepicker>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'

    export default {
      props: ['value', 'field', 'validationScope'],
      inject: ['$validator'],
      data: function () {
        return {
          date: null
        }
      },
      computed: {
        locale: function () {
          return this.$store.state.locale
        }
      },
      components: {
        Datepicker
      },
      watch: {
        date: function (newVal, oldVal) {
          this.$emit('input', newVal)
        }
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

</style>

<style>

 .cst-survey-datepicker input {
    background-image: url("../assets/ico_calendar.svg");   
    background-position: right center;
    background-repeat: no-repeat;
 }
</style>


// WEBPACK FOOTER //
// src/components/AppDatePicker.vue